/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <gnu.org/licenses>.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
    <div :class="addFadeIn ? 'mc-banner-badge fade-in-badge' : 'mc-banner-badge'">
      <p v-if="badge.type === 'RewardStep'">
        <b>{{badge.title}}</b>. Bravo ! Bientôt, le badge <b>{{badge.badge.title}}</b> ?
      </p>
      <div v-if="badge.type !== 'RewardStep'" class="text-center">
        <img style="width: 100%; border-radius: 20px" :src="badge.pictures.image" :onload="changeFadeIn()" /><br>
        <div style="margin-top: 10px">Bravo ! Vous avez obtenu le badge</div>
        <h1 style="margin-top: 10px">{{badge.title}}</h1>
      </div>
      <ion-fab style="display: flex;" horizontal="end" slot="fixed">
        <ion-fab-button v-on:click="close" color="secondary">
          <ion-icon name="close"></ion-icon>
        </ion-fab-button>
        <ion-fab-button v-if="badge.type === 'Badge'" class="ion-margin-start" v-on:click="redirectToMyBadges" color="secondary">
          <ion-icon name="arrow-forward"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    </div>


</template>

<style lang="scss">
.mc-banner-badge {
  position: relative;
  z-index: 1;
  padding: 10px;
  margin: 10px;
  margin-bottom: 50px;
  background: white;
  border-radius: 30px;
  border: 2px solid var(--ion-color-secondary);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 6px 10px 0px, rgba(0, 0, 0, 0.12) 0px 1px 18px 0px;
  p {
    font-size: 0.9rem;
    margin : 5px;

    color: #000000;
  }
}
</style>

<script>
export default {
  name: "banner-completed-action",
  props: ['badge'],
  data: function() {
    return {
      addFadeIn: false
    };
  },
  created() {
    if (this.badge.type === 'RewardStep') {
      this.changeFadeIn();
    }
  },
  methods: {
    changeFadeIn() {
      this.addFadeIn = true;
    },
    close() {
      this.$store.commit('remove_displayed_badges', this.badge);
    },
    redirectToMyBadges() {
      this.$store.commit('set_win_badge', this.badge);
      this.$router.push({ name: "win-badge", query: { id: this.badge.id } });
      this.close();
    }
  }
};
</script>
